// test350
(350 && 0);
